<div class="reassign-modal">
  <div class="modal-header">
    <div class="title-section">
      <h2>Add Task Assignee</h2>
    </div>
    <mat-icon class="close-icon" (click)="onCancel()">close</mat-icon>
  </div>
  <div class="modal-body">
    <form [formGroup]="reassignForm">
      <user-autocomplete [label]="'Attendees'" formControlName="attendeesIds"
        [searchFn]="searchUserDataList"></user-autocomplete>
    </form>
  </div>

  <div class="modal-footer">
    <button class="cancel-btn" (click)="onCancel()">Cancel</button>
    
    <button type="button" class="v-button v-button-md v-green" (click)="onSave()" [disabled]="loading">

      <ng-container *ngIf="!loading">Save <span class="material-icons"
          style="font-size: 16px; margin-left: 5px; vertical-align: middle;">check</span></ng-container>

      <ng-container *ngIf="loading">
        <i class="pi pi-spin pi-spinner mr-2"></i>
        Saving...
      </ng-container>
    </button>
  </div>
</div>